import {MonthIndex} from '@zentact/common';
import {DateTime} from 'luxon';

export const getStartOfTheMonth = (year: number, month: MonthIndex) => {
  return DateTime.local(year, month + 1);
};
